import { Routes } from '@angular/router';
import { AuthGuard } from '@core/guards/auth-guard';
import { stateGuard } from '@core/guards/state.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full' },

  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routing').then((r) => r.authRouting),
  },
  {
    path: 'portal',
    loadChildren: () => import('./usuario/portal/portal.routing').then((r) => r.portalRouting),
    canActivate: [AuthGuard],
  },
  {
    path: 'editar-perfil-usuario',
    loadChildren: () => import('./usuario/editar-perfil-usuario/editar-perfil-usuario.routing').then((r) => r.editarPerfilusuariosRouting),
  },
  {
    path: 'configuraciones',
    loadChildren: () => import('./modulos/configuraciones/configuracion.routing').then((r) => r.configuracionesRouting),
    canActivate: [AuthGuard],
  },
  {
    path: 'reer',
    loadChildren: () => import('./modulos/reer/reer.routing').then((r) => r.reerRouting),
    canActivate: [AuthGuard],
  },
  {
    path: 'reclamos',
    loadChildren: () => import('./modulos/gestion-reclamos/gestion-reclamos.routing').then((r) => r.gestionReclamosRouting),
    canActivate: [AuthGuard],
  },
  {
    path: 'establecimientos',
    loadChildren: () => import('./modulos/establecimientos/establecimientos.routing').then((r) => r.establecimientosRouting),
    canActivate: [AuthGuard],
  },
  {
    path: 'padrones-nativos',
    loadChildren: () => import('./modulos/padron-nativos/padron-nativos.routing').then((r) => r.padronNativosRouting),
    canActivate: [AuthGuard],
  },
  {
    path: 'autogestion',
    loadChildren: () => import('./modulos/autogestion/autogestion.routing').then((r) => r.autogestionnesRouting),
    canActivate: [AuthGuard],
  },
  {
    path: 'autoridades-mesa',
    loadChildren: () => import('./modulos/autoridades-mesa/autoridades-mesa.routing').then((r) => r.autoridadesMesaRouting),
  },
  {
    path: 'siel',
    loadChildren: () => import('./modulos/siel/siel.routing').then((r) => r.sielRouting),
  },
  {
    path: 'delegados-judiciales',
    loadChildren: () =>
      import('./modulos/delegados/delegados.routing')
        .then((r) => r.delegadosRouting),
  },
  { path:'escrutinio',
    canActivate:[AuthGuard],
    loadChildren: () => import('./modulos/escrutinio/escrutinio.routing').then((r) => r.escrutinioRouting),
  },
];
